module.exports = __webpack_public_path__ + "static/media/the-social-logo-dark.e26868a9.svg";